import { QueryClient } from '@tanstack/react-query'

// No retries by default: this is an auth-gated app and the session check returns a
// fast 401 when unauthenticated — retrying it just delays the redirect to /login.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
})
